import colors from '@audioeye-marketing/ui/src/theme/colors'

/**
 * @param {string} text - the text you want to have searched and styled
 * @return {array} - array of objects with a search_term and array of strings of styles to apply
 */
const generateTextStyles = ({ text, styles }) => {
  if (styles?.length === 0 || !styles) return text

  const parts = []
  let lastIndex = 0
  const matches = []

  styles.forEach(({ search_term: term, styles }) => {
    const regex = new RegExp(term, 'gi')
    let match

    while ((match = regex.exec(text)) !== null) {
      matches.push({
        start: match.index,
        end: match.index + match[0].length,
        term: match[0],
        styles,
      })
    }
  })

  matches.sort((a, b) => a.start - b.start)

  for (let i = 0; i < matches.length; i++) {
    const { start, end, term, styles } = matches[i]

    if (start < lastIndex) continue

    if (start > lastIndex) {
      parts.push(text.slice(lastIndex, start))
    }

    const element = (
      <span key={term} style={styles.length > 0 ? getStyles(styles) : {}}>
        {term}
      </span>
    )

    parts.push(element)
    lastIndex = end
  }

  // Add any remaining text
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex))
  }

  return parts
}

const getStyles = (styles) => {
  return styles.reduce((acc, currentStyle) => {
    switch (currentStyle) {
      case 'italics':
        return { ...acc, fontStyle: 'italic' }
      case 'accent':
        return { ...acc, color: colors.success[300] }
      case 'bold':
        return { ...acc, fontWeight: 'bold' }
      default:
        return acc
    }
  }, {})
}

export default generateTextStyles
